import { Component, Input, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'Amarillas-create-currency',
  templateUrl: './create-currency.component.html',
  styleUrls: ['./create-currency.component.scss'],
})
export class CreateCurrencyComponent implements OnInit {
  @Input() onEditCurrency:any;
  currencyForm: UntypedFormGroup;

  constructor(
    private fb: UntypedFormBuilder,
    private modalController: ModalController
  ) { }

  ngOnInit() {
    this.currencyForm = this.fb.group({
      name: ['', [Validators.required]],
      symbol: ['', [Validators.required, Validators.maxLength(5)]],
      change: ['', [Validators.required]],
      type: ['', [Validators.required]]
    })

    if(this.onEditCurrency){
      this.currencyForm.patchValue(this.onEditCurrency);
    }
  }

  closeModal(closed){
    this.modalController.dismiss(closed ? null : this.currencyForm.value, this.onEditCurrency ? 'edit' : 'create');
  }

}
